export default "__VITE_ASSET__BSFGm5rO__"